
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[alias]",
      function () {
        return require("private-next-pages/[alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[alias]"])
      });
    }
  